<!--
  AI:
  Status: "in progress"
  Type: Page Template
  SubType: Overview (shell-consultant)
  Reason: „Kunden in meiner Nähe" in the Co-App - only the shared component, full width. No page
          header: the component's own toolbar (place search + „Mein Standort") is its top row, like
          the sibling consultant pages (my-customers, Kundenanlage) that render no title of their own.
-->
@if (initialized) {
    <cr-nearby-customers (onCustomerSelect)="handleCustomerSelect($event)"></cr-nearby-customers>
}
